var exports = {
  "k": "xe533113f--3c01f5--container",
};

module.exports = exports;
